import { render, staticRenderFns } from "./BrandSampleUI.vue?vue&type=template&id=d12a0984&"
import script from "./BrandSampleUI.vue?vue&type=script&lang=ts&"
export * from "./BrandSampleUI.vue?vue&type=script&lang=ts&"
import style0 from "./BrandSampleUI.vue?vue&type=style&index=0&id=d12a0984&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports